import { withInstall } from '@vuesax-plus/utils'
import Switch from './src/switch.vue'

export const VsSwitch = withInstall(Switch)
export default VsSwitch

export * from './src/switch'
